import sentryMenu from "../../../app-shell/resources/sentry-menu.js";
import submenu from "../../../app-shell/resources/submenu.js";
import {buildMenu} from "../../../app-shell/utils/menu-filter.js";

const isSelectable = (node) =>
    !!node.name && !!node.url && node.url !== "#" && !node.horizontalRule;

const prepareMenu = (nodes, trail = [], acc = []) => {
    for (const node of Array.isArray(nodes) ? nodes : []) {
        if (Array.isArray(node.items) && node.items.length) {
            prepareMenu(node.items, node.name ? [...trail, node.name] : trail, acc);
            continue;
        }

        // "Grupo / Sub / Nome" trail.
        if (isSelectable(node)) acc.push({...node, path: [...trail, node.name].join(" / ")});
    }

    return acc;
};

export const homeMenuItems = (ctx) => prepareMenu(buildMenu(sentryMenu.menu, ctx, "sentry"));

export const resolveSavedCards = (cards, ctx) => {
    const byId = new Map(
        [...homeMenuItems(ctx), ...prepareMenu(buildMenu(submenu, ctx, "sentry"))]
            .map((item) => [item.id, item]),
    );

    return (Array.isArray(cards) ? cards : [])
        .map((card) => {
            const item = byId.get(card.id);
            return item ? {...card, url: item.url} : null;
        })
        .filter(Boolean);
};
